export default "__VITE_ASSET__76ddec50__"